<ion-header>
  <ion-toolbar>
    <ion-title>{{isEdit ? ('Update League' | translate) : ('Create League' | translate)}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form *ngIf="form" [formGroup]="form">
    <ion-list>

      <ion-item button (click)="changeDatetime('startDate')">
        <ion-label position="stacked">{{ 'Start date' | translate }}</ion-label>
        <ion-text>{{ form.get('startDate').value | date: 'MMMM d, y' }}</ion-text>
      </ion-item>

      <ion-item button (click)="changeDatetime('endDate')">
        <ion-label position="stacked">{{ 'End date' | translate }}</ion-label>
        <ion-text>{{ form.get('endDate').value | date: 'MMMM d, y' }}</ion-text>
      </ion-item>

      <ion-item>
        <ion-input label="{{ 'Name' | translate }}" label-placement="floating" type="text" formControlName="name"></ion-input>
      </ion-item>

      <ion-item>
        <ion-input label="{{ 'URL Segment' | translate }}" label-placement="floating" type="text" formControlName="urlSegment"></ion-input>
      </ion-item>

      <ion-item>
        <ion-toggle justify="space-between" formControlName="isPublic" tranlsate>{{'Public' | translate}}</ion-toggle>
      </ion-item>

        <app-select-organisation
                [organisationId]="form.get('organisation')?.value"
                [policyId]="form.get('policy')?.value"
                (organisationChange)="form.get('organisation').setValue($event)"
                (policyChange)="form.get('policy').setValue($event)">
        </app-select-organisation>
    </ion-list>
  </form>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-button class="ion-margin" (click)="createLeague()" expand="block">
      <span transalte *ngIf="!isSubmitting">{{ leagueActionText | translate }} </span>
      <ion-spinner name="crescent" *ngIf="isSubmitting"></ion-spinner>
    </ion-button>
  </ion-toolbar>
</ion-footer>